module.exports = __webpack_public_path__ + "media/images/svg/robles_center-2645fc3df54ed7fabb83cdf13608740d.svg";